import React from 'react';
import Container from '../Layout/Container';
import { Box } from '../Layout';
import { Link } from '../Typography';

const NationalTeams = () => (
  <Container>
    <Box>
      <h1>2024 National Calendar</h1>
      <p>15-17 March, Mens Blind Football National Camp &ndash; Melbourne</p>
      <p>24-26 May, Mens Blind Football National Camp &ndash; Melbourne</p>
      <p>19-21 July, Blind Football National Camp (Male and Female) &ndash; Melbourne</p>
      <p>13-15 September, Blind Football National Camp (Male and Female) &ndash; Melbourne</p>
      <p>Note: Additional National Camps may be added during 2024.</p>
      <h1>National teams</h1>
      <h2>Australian Blind Football Squads</h2>
      <p>
        <strong>Mens Blind Football Squad</strong>
      </p>
      <p>Victoria &ndash; Amir Brand-Abdi, Brendan Spencer, Nathan Letts, Brad Pinkett</p>
      <p>Queensland &ndash; Shahram Jazan, Nizamuddin Azimi</p>
      <p>South Australia &ndash; Isaiah Muller, Tyson Fielding</p>
      <p>Northern Territory &ndash; Aaron Occleshaw</p>
      <p>Goalkeepers &ndash; Nathan Meneses, Simon Briffa </p>
      <p>
      <strong>Womens Blind Football squad</strong>
      </p>
      <p>
        Australian Blind Football's Womens Blind Football squad for 2024 will be announced online shortly.{' '}
      </p>      
      <p>
        <strong>Partially Sighted Futsal squad</strong>
      </p>
      <p>
        Australian Blind Football's Partially Sighted Futsal program will announce details of upcoming events shortly.{' '}
      </p>
      <p>
        Attendance at the camps is for selected players only. Contact{' '}
        <Link
          href="mailto:football@blindsportsaustralia.com.au"
          target="_top"
          aria-label="Contact Blind Football Australia"
        >
          football@blindsportsaustralia.com.au
        </Link>{' '}
        for more information about trials and local ABF4ALL programs.
      </p>
    </Box>
  </Container>
);

export default NationalTeams;



// WEBPACK FOOTER //
// ./src/NationalTeams/NationalTeams.js